<div class="forgot-password-wrapper">
    <div class="forgot-password-header">
        <button type="button" class="back-button" (click)="onBackClick()">
            <i class="bi bi-chevron-left"></i>
            {{ 'FORGOT_PASSWORD.BACK' | translate }}
        </button>
        <h1 class="forgot-password-title">{{ 'FORGOT_PASSWORD.TITLE' | translate }}</h1>
        <p class="forgot-password-subtitle">{{ 'FORGOT_PASSWORD.SUBTITLE' | translate }}</p>
    </div>

    <!-- Toast Notification -->
    <app-toast class="toast-wrapper"></app-toast>

    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-form">
        <!-- Email Field -->
        <div class="form-group">
            <label for="forgot-email" class="form-label">
                <span class="required-asterisk">*</span> {{ 'LOGIN.EMAIL' | translate }}
            </label>
            <div class="input-wrapper">
                <input type="email" id="forgot-email" formControlName="email" class="form-control"
                    [class.is-invalid]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched"
                    [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate" />
                <i class="bi bi-exclamation-triangle input-error-icon"
                    *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched"></i>
            </div>
            <div class="invalid-feedback"
                *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched">
                {{ getErrorMessage() }}
            </div>
        </div>

        <!-- Reset Password Button -->
        <button type="submit" class="btn btn-primary btn-reset-password" [disabled]="isLoading">
            <span *ngIf="!isLoading">{{ 'FORGOT_PASSWORD.RESET_PASSWORD' | translate }}</span>
            <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Loading...
            </span>
        </button>
    </form>
</div>